var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaturedCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 22.0002V26.0002M24.9998 30.0002H25.0098M23.6151 16.892L15.3902 31.0986C14.934 31.8866 14.7059 32.2806 14.7396 32.6039C14.769 32.886 14.9168 33.1423 15.1461 33.309C15.4091 33.5002 15.8643 33.5002 16.7749 33.5002H33.2246C34.1352 33.5002 34.5904 33.5002 34.8534 33.309C35.0827 33.1423 35.2305 32.886 35.2599 32.6039C35.2936 32.2806 35.0655 31.8866 34.6093 31.0986L26.3844 16.892C25.9299 16.1068 25.7026 15.7142 25.4061 15.5824C25.1474 15.4673 24.8521 15.4673 24.5935 15.5824C24.2969 15.7142 24.0696 16.1068 23.6151 16.892Z",
    stroke: "#D92D20",
    strokeOpacity: 0.87,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 10.5,
    stroke: "#D92D20",
    strokeOpacity: 0.87
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedCancel);
export default __webpack_public_path__ + "static/media/featuredCancel.8b1d845adba2e729c86fe1b5ba428ae6.svg";
export { ForwardRef as ReactComponent };